import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ReporteFacturacionComponent } from './ReporteFacturacion.component';
import { CierreFacturacionElectronicaComponent } from './CierreFacturacionElectronica.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'ReporteFacturacionElectronica',
        component: ReporteFacturacionComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReporteFacturacionElectronica',
          nombreFormulario : 'ReporteFacturacionElectronica'
        } 
    },{
        path     : 'CierreFacturacionElectronica',
        component: CierreFacturacionElectronicaComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CierreFacturacionElectronica',
          nombreFormulario : 'CierreFacturacionElectronica'
        } 
        
    }
];

@NgModule({
    declarations: [
        ReporteFacturacionComponent,
        CierreFacturacionElectronicaComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReporteFacturacionComponent,
        CierreFacturacionElectronicaComponent
    ]
})

export class ReporteFacturacionModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReporteFacturacion/ReporteFacturacion.module.ts